/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/display-name */
import { type Ref, forwardRef } from 'react'
import Input from 'react-phone-number-input/input'
import { type IInputCommonProps, type IInputComponent, type IInputPhoneProps } from './types'

const InputPhoneNumberRef = (props: IInputPhoneProps, ref: Ref<HTMLInputElement>) => {
  const { country, isInternational = false, onPhoneValueChange, ...rest } = props
  return (
    <Input
      ref={ref}
      international={isInternational}
      country={country}
      {...rest}
      onChange={(val) => onPhoneValueChange?.(val ?? '')}
    />
  )
}

export const InputPhoneNumber: IInputComponent<IInputPhoneProps & IInputCommonProps> =
  forwardRef(InputPhoneNumberRef)
